import {Component, HostListener, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { AuthService } from 'src/app/_core/auth.service';

@Component({
    selector: 'app-external-pay-dialog',
    templateUrl: './external-pay-dialog.component.html',
    styleUrls: ['./external-pay-dialog.component.scss'],
    standalone: false
})
export class ExternalPayDialogComponent {

	trustedIframeUrl: SafeResourceUrl;
	saveToWallet: any = false;

	/*@HostListener('window:message', ['$event'])
	onMessage(e) {
		debugger;
		// if (e.data?.adyenPayload) this.applyPayment(e.data );
	}*/

	constructor(
		private sanitizer: DomSanitizer,
		public appService: AppService,
		public entityService: EntityService,
		public authService: AuthService,
		public dialogRef: MatDialogRef<ExternalPayDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.trustedIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.redirectURL);
	}

	onFrameLoaded(ev) {
		try {
			const _location = ev.currentTarget.contentWindow.location;
			console.log("EXTERNAL PAY DIALOG", _location);
			const href = _location.href;
			if (href && href.indexOf('expayment_ret.html') != -1) {
				let params = this.appService.getURLParams(_location);
				switch (this.data.provider) {
					case "tabit":
						this.handleTabitPaymentResponse(params, ev);
						break;
					case "CreditGuard": ;
					case "Meshulam":
						switch (params.r) {
							case "success":
								this.dialogRef.close({ mode: "success", saveToWallet: this.saveToWallet });
								break;
							case "error":
								this.dialogRef.close({ mode: "error" });
								break;
							case "cancel":
								this.dialogRef.close({mode: "cancel"});
								break;
						}
						break;
					default:
						this.dialogRef.close(params);
				}
			}
		} catch (e) {

		}
	}

	private handleTabitPaymentResponse(params: any, event?: Event): void {
		const result = params.result || params.r;
		switch (result) {
			case 'success':
				params.payment = JSON.parse(decodeURIComponent(params.payment));
				const props = ['payment', 'saveCard'];
				props.forEach((key) => {
					try {
						params[key] = JSON.parse(decodeURIComponent(params[key]));
					} catch (e) {
					}
				});
				const saveCard: boolean = params?.saveCard?.saved ?? false;
				if (saveCard) params.saveToWallet = saveCard;
				this.dialogRef.close({ mode: 'success', params });
				break;
			case 'error':
				this.dialogRef.close({ mode: 'error', error: event });
				break;
			case 'cancel':
				this.dialogRef.close({ mode: 'cancel' });
				break;
		}
	}

	close() {
		this.dialogRef.close({ mode: "cancel" });
	}

	markSaveToWalletPayment(ev) {
        if (!ev) return;
        this.saveToWallet = ev.checked;
    }

    get showAddToWallet() {
        return this.authService.isAuthenticated() && !this.data?.addToWallet;
    }
}
